const zones = [
  {
    id: "zone-01",
    title: "Photo Shoots",
    desc: "A thoughtfully curated studio with 6 curated walls & setups and 4 movable backdrops — a different setting for every idea.",
    specs: ["6 curated studio walls & setups", "4 movable backdrops", "Chairs & selected props included"],
    featured: false,
  },
  {
    id: "zone-02",
    title: "Video Shoots & Content Creation",
    desc: "A comfortable, fully air-conditioned space that adapts to your concept — from reels and interviews to brand content.",
    specs: ["Fully air-conditioned studio", "Separate makeup & changing room", "High-speed Wi-Fi"],
    featured: true,
  },
  {
    id: "zone-03",
    title: "Workshops",
    desc: "A versatile setting for workshops and small group sessions — style the space to fit your format with props and movable sets.",
    specs: ["Movable backdrops & sets", "Pantry area & washroom", "Mini refrigerator on-site"],
    featured: false,
  },
];

const gear = [
  { title: "Vases", desc: "Decorative vessels for styling", cat: "small-vases" },
  { title: "Rugs", desc: "Styled area rugs for set dressing", cat: "rugs" },
  { title: "Artificial Plants", desc: "Greenery for natural set looks", cat: "artificial-plants" },
  { title: "Chairs & More", desc: "Seating and styling extras", cat: "chairs" },
];

export const Services = () => (
  <>
    <section id="specs" data-testid="services-section" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <span className="label-caps text-forest block mb-2">What Room 9 Is For</span>
          <h2 data-testid="services-heading" className="heavy-heading text-3xl sm:text-4xl font-extrabold text-ink">
            One Space. Every Kind of Shoot.
          </h2>
          <p className="text-sm sm:text-base text-muted-g mt-2">
            Photography, video shoots, content creation and workshops — the space adapts to your
            ideas, aesthetics and concepts.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {zones.map((z) => (
            <article
              key={z.id}
              data-testid={`service-card-${z.id}`}
              className={`bg-bg rounded-xl border p-6 space-y-4 ${z.featured ? "border-forest shadow-sm" : "border-line"}`}
            >
              <h3 className="text-xl font-bold text-ink">{z.title}</h3>
              <p className="text-sm text-muted-g leading-relaxed">{z.desc}</p>
              <div className="pt-4 border-t border-line text-xs font-semibold text-muted-gd space-y-1">
                {z.specs.map((s) => (
                  <p key={s}>• {s}</p>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section id="inventory" data-testid="props-section" className="py-16 bg-bg border-y border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center mb-12">
          <span className="label-caps text-forest block mb-2">Props at Room 9</span>
          <h2 className="heavy-heading text-3xl sm:text-4xl font-extrabold text-ink mb-5">Style it your way.</h2>
          <p data-testid="props-description" className="text-base sm:text-lg text-muted-gd leading-relaxed mb-6">
            Explore a curated selection of props available at the studio to complement your mood
            board and bring your shoot to life. You are free to bring any of the props which blends
            with your mood board and aligns best with your shoot.
          </p>
          <span
            data-testid="props-included-badge"
            className="inline-flex items-center gap-2 bg-forest text-white text-xs font-bold uppercase tracking-wider px-4 py-2 rounded-lg shadow-sm"
          >
            ✓ Included free with every booking
          </span>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {gear.map((g) => (
            <div
              key={g.title}
              data-testid={`prop-card-${g.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="bg-white p-4 rounded-lg border border-line"
            >
              <p className="font-bold text-sm text-ink">{g.title}</p>
              <p className="text-xs text-muted-g">{g.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);
